/**
 * Bill Credits container
 */

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import billCreditsActions from './actions';
import BillCreditDetail from '../../Components/BillCreditDetail/BillCreditDetail.tsx';
import {
  loadingSelector,
  billCreditSelector,
  errorSelector,
} from './selectors';

const { getBillCredit } = billCreditsActions;

/**
 * Properties to be provided to the bill credits component
 *
 * @param {object} state global state
 */
const mapStateToProps = (state) => ({
  billCredit: billCreditSelector(state),
  loading: loadingSelector(state),
  error: errorSelector(state),
});

/**
 * Actions to be dispatched
 *
 * @param {function} dispatch function to dispatch bill credit actions
 */
const mapDispatchToProps = (dispatch) => ({
  getBillCredit: (userId, billCreditId) =>
    dispatch(getBillCredit(userId, billCreditId)),
});

/**
 * Connects state to the Bill Credit Detail component
 *
 * @param {object} mapStateToProps data object to become props for the Bill Credit component
 * @param {object} mapDispatchToProps Bill Credit actions to be dispatched to reducer
 */
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BillCreditDetail),
);
